import type { NavItem, NavGroup, SocialLink } from "@/types";
import { X, Linkedin, Github, Dribbble } from "@/icons";
// import { Twitter, Linkedin, Github, Dribbble } from "@/icons";
import { siteConfig } from "@/config/site.config";

/** Primary header navigation. */
// export const mainNav: NavItem[] = [
//   { label: "Services", path: "/services", description: "What we do" },
//   { label: "Solutions", path: "/solutions", description: "Outcomes we drive" },
//   { label: "Industries", path: "/industries", description: "Who we serve" },
//   { label: "Portfolio", path: "/portfolio", description: "Selected work" },
//   { label: "About", path: "/about", description: "The studio" },
//   { label: "Insights", path: "/insights", description: "Ideas & writing" },
// ];

export const mainNav: NavItem[] = [
  { label: "Services", path: "/services", description: "Technology solutions for modern businesses" },
  { label: "Solutions", path: "/solutions", description: "Business solutions tailored to your goals" },
  { label: "Industries", path: "/industries", description: "Industries we empower" },
  { label:"Technologies", path:"/technologies", description: "Modern technologies powering our solutions" },
  { label: "About", path: "/about", description: "Learn about VibeWell Software Solutions" },
  { label:"Contact", path:"/contact", description: "Lets discuss your next digital initiative" }
];

/** Grouped footer navigation. */
export const footerNav: NavGroup[] = [
  {
    title: "Explore",
    items: [
      { label: "Services", path: "/services" },
      { label: "Solutions", path: "/solutions" },
      { label: "Industries", path: "/industries" },
      { label: "Technologies", path: "/technologies" },
      // { label: "Portfolio", path: "/portfolio" },
      // { label: "Case Studies", path: "/case-studies" },
    ],
  },
  {
    title: "Company",
    items: [
      { label: "About", path: "/about" },
      // { label: "Technologies", path: "/technologies" },
      { label: "Insights", path: "/insights" },
      { label: "Process", path: "/process" },
      { label: "Contact", path: "/contact" },
    ],
  },
  {
    title: "Resources",
    items: [
      { label: "FAQ", path: "/faq" },
      { label: "Privacy Policy", path: "/privacy" },
      { label: "Terms of Service", path: "/terms" },
    ],
  },
];

export const socialLinks: SocialLink[] = [
  { label: "Twitter", href: siteConfig.social.twitter, icon: X },
  { label: "LinkedIn", href: siteConfig.social.linkedin, icon: Linkedin },
  { label: "GitHub", href: siteConfig.social.github, icon: Github },
  // { label: "Dribbble", href: siteConfig.social.dribbble, icon: Dribbble },
];
